/* pl-foxkit-upsell-sort.js
   1. Excludes Build-A-Bundle parent products from every FoxKit in-cart offer.
   2. Visually reverses the slide order for the configured offer.

   FoxKit renders and refreshes its cart recommendations asynchronously, so
   both rules are reapplied by one shared MutationObserver. */
(function () {
  'use strict';

  var OFFER_ID = '69f8e57042a55489715de1c3';
  var FOXKIT_LIST_SELECTOR = 'foxkit-incart-upsell .f-incart__products';
  var SORT_LIST_SELECTOR =
    'foxkit-incart-upsell[data-offer-id="' + OFFER_ID + '"] .f-incart__products';
  var BUNDLE_TEXT_PATTERN =
    /build[\s\u2010-\u2015-]*(?:a[\s\u2010-\u2015-]*bundle|your[\s\u2010-\u2015-]*recovery[\s\u2010-\u2015-]*system)/i;

  function isBundleCard(card) {
    var links = card.querySelectorAll('a[href*="/products/"]');

    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href') || '';
      if (BUNDLE_TEXT_PATTERN.test(decodeURIComponent(href).replace(/[-_]+/g, ' '))) {
        return true;
      }
    }

    return BUNDLE_TEXT_PATTERN.test(card.textContent || '');
  }

  function excludeBundleProducts() {
    var lists = document.querySelectorAll(FOXKIT_LIST_SELECTOR);

    for (var i = 0; i < lists.length; i++) {
      var list = lists[i];
      var cards = Array.prototype.slice.call(list.children);
      var visibleCount = 0;

      for (var j = 0; j < cards.length; j++) {
        var card = cards[j];
        var exclude = isBundleCard(card);

        card.classList.toggle('pl-foxkit-bundle-excluded', exclude);
        card.hidden = exclude;
        card.setAttribute('aria-hidden', exclude ? 'true' : 'false');
        card.style.setProperty('display', exclude ? 'none' : '', exclude ? 'important' : '');

        var controls = card.querySelectorAll('button, input, select, a');
        for (var k = 0; k < controls.length; k++) {
          if (exclude) {
            if (!controls[k].hasAttribute('data-pl-bundle-disabled')) {
              controls[k].setAttribute(
                'data-pl-original-tabindex',
                controls[k].hasAttribute('tabindex') ? controls[k].getAttribute('tabindex') : '__none__'
              );
              if (controls[k].tagName === 'BUTTON') {
                controls[k].setAttribute('data-pl-original-disabled', controls[k].disabled ? 'true' : 'false');
              }
              controls[k].setAttribute('data-pl-bundle-disabled', 'true');
            }
            controls[k].setAttribute('tabindex', '-1');
            if (controls[k].tagName === 'BUTTON') controls[k].disabled = true;
          } else if (controls[k].hasAttribute('data-pl-bundle-disabled')) {
            var originalTabindex = controls[k].getAttribute('data-pl-original-tabindex');
            if (originalTabindex === '__none__') {
              controls[k].removeAttribute('tabindex');
            } else {
              controls[k].setAttribute('tabindex', originalTabindex);
            }
            if (controls[k].tagName === 'BUTTON') {
              controls[k].disabled = controls[k].getAttribute('data-pl-original-disabled') === 'true';
            }
            controls[k].removeAttribute('data-pl-bundle-disabled');
            controls[k].removeAttribute('data-pl-original-tabindex');
            controls[k].removeAttribute('data-pl-original-disabled');
          }
        }

        if (!exclude) visibleCount++;
      }

      var offer = list.closest('foxkit-incart-upsell');
      if (offer) {
        offer.hidden = visibleCount === 0;
        offer.setAttribute('aria-hidden', visibleCount === 0 ? 'true' : 'false');
      }
    }
  }

  function applyOrder() {
    var lists = document.querySelectorAll(SORT_LIST_SELECTOR);
    for (var i = 0; i < lists.length; i++) {
      var list = lists[i];
      var kids = Array.prototype.filter.call(list.children, function (card) {
        return !card.classList.contains('pl-foxkit-bundle-excluded');
      });
      if (kids.length < 2) continue;

      var sig = kids.length + ':' + (kids[0].getAttribute('data-product-id') || '');
      if (list.dataset.plSig === sig) continue;

      for (var j = 0; j < kids.length; j++) {
        kids[j].style.order = String(kids.length - j);
      }
      list.dataset.plSig = sig;
      list.dispatchEvent(new Event('scroll', { bubbles: true }));
    }
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      excludeBundleProducts();
      applyOrder();
    });
  }

  function init() {
    excludeBundleProducts();
    applyOrder();
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
